import React from 'react';
import './ProfileCard.css';

interface ProfileCardProps {
  name: string;
  image: string;
  description?: string;
  onClick: () => void;
}

const ProfileCard: React.FC<ProfileCardProps> = ({ name, image, description, onClick }) => {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <article
      className="profile-card"
      onClick={onClick}
      onKeyDown={handleKeyDown}
      role="listitem"
      tabIndex={0}
      aria-label={`${name} profile${description ? `: ${description}` : ''}`}
    >
      <div className="image-container">
        <img
          src={image}
          alt={`${name} viewing profile avatar`}
          className="profile-image"
          width="150"
          height="150"
          loading="eager"
        />
      </div>
      <h3 className="profile-name">{name}</h3>
      {description && (
        <p className="profile-description visually-hidden">{description}</p>
      )}
    </article>
  );
};

export default ProfileCard;
